import { render, staticRenderFns } from "./serviceObjectFeedbackList.vue?vue&type=template&id=39f1769a&scoped=true&"
import script from "./serviceObjectFeedbackList.vue?vue&type=script&lang=ts&"
export * from "./serviceObjectFeedbackList.vue?vue&type=script&lang=ts&"
import style0 from "./serviceObjectFeedbackList.vue?vue&type=style&index=0&id=39f1769a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1769a",
  null
  
)

export default component.exports